'use client';

import { Document } from '@contentful/rich-text-types';
import { FC } from 'react';
import MainBodyToReact from '../MainBodyToReact';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import CustomImage from '@/components/CustomImage/CustomImage';

export type TIconTile = {
    id?: string;
    title: string;
    image?: string;
    summary1?: string;
    summary2?: string;
    summaryDoc?: Document;
};

const TileWithIcIcon: FC<TIconTile> = ({ id, title, image, summary1, summary2, summaryDoc }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div className="tw-w-full tw-bg-white tw-rounded-lg tw-px-[15px] tw-py-[20px]">
            {image && (
                <CustomImage
                    width={42}
                    height={42}
                    src={image}
                    alt={title}
                    className="tw-object-cover tw-w-[42px] lg:tw-w-[49px]"
                    {...inspectorProps({
                        fieldId: 'icon',
                    })}
                />
            )}
            <div className="tw-pt-[20px]">
                <h2
                    className="tw-text-[16px] lg:tw-text-[14px] xl:tw-text-[16px] tw-font-gotham-bold tw-text-[#003865] tw-pb-[10px]"
                    {...inspectorProps({
                        fieldId: 'title',
                    })}
                >
                    {title}
                </h2>
                {!summaryDoc ? (
                    <p className="tw-text-[14px] tw-font-gotham-book tw-text-[#4b4f54] tw-leading-5">
                        {summary1}
                        <br />
                        {summary2}
                    </p>
                ) : (
                    <MainBodyToReact
                        body={summaryDoc}
                        classes={{
                            p: 'tw-text-[14px] tw-font-gotham-book tw-text-[#4b4f54] tw-leading-5 !tw-pb-0',
                        }}
                        fieldId="content"
                        id={id}
                    />
                )}
            </div>
        </div>
    );
};

export default TileWithIcIcon;
